export default __webpack_public_path__ + "static/media/K-Brielly logo.6a9eb085.png";